import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { editLandingPage, getPages, resetPages } from '../../../redux/actions/pagesActions'
import { qlikLoginSSO } from '../../../redux/actions/authActions'
import Header from '../../layout/Partials/Header'

import Error from '../../common/Error'
import Loading from '../../common/Loading'
import AccessDenied from '../../common/AccessDenied'
import { Theme } from '../../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import AdminLayout from '../../layout/AdminLayout'
import DataTable from 'react-data-table-component'
import TableActions from './Partials/TableActions'
import IsLandingTableBadge from './Partials/IsLandingTableBadge'
import Section from '../../UI/Section'
import { Box } from '@material-ui/core'

const styles = Theme()

class Pages extends Component {
  constructor(prop) {
    super(prop)

    this.state = {
      errors: {},
      pages: null,
    }

    this.updateLandingPage = this.updateLandingPage.bind(this)

    this.columns = [
      {
        name: 'Title',
        selector: 'title',
        sortable: true,
        left: true,
      },
      {
        name: 'Status',
        selector: 'status',
        hide: 'sm',
        sortable: true,
        center:true,
      },
      {
        name: 'Menu Visible',
        selector: 'menu',
        hide: 'sm',
        sortable: true,
        center:true,
        format: page => (
            <div>
              {page.menu === 'yes' ? (
                  <span className={'c-badge c-badge--success '}>Yes</span>
              ) : (
                  <span className={'c-badge c-badge--danger'}>NO</span>
              )}
            </div>
        ),
      },
      {
        name: 'Landing Page',
        minWidth: 200,
        cell: page => (
          <IsLandingTableBadge page={page} classes={this.props.classes} updateLandingPage={this.updateLandingPage} />
        ),
        sortable: false,
        center:true,
      },
      {
        name: 'Actions',
        minWidth: 320,
        cell: page => <TableActions page={page} classes={this.props.classes} />,
        sortable: false,
        center:true,
      },
    ]
  }

  updateLandingPage(makeLanding) {
    this.props.editLandingPage(makeLanding)
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors })
    }
    if (nextProps.pages) {
      this.setState({ makeLanding: null })
    }
    if (nextProps.location.key !== this.props.location.key) {
      this.getPages()
    }
  }

  // UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
  //   if (nextProps.location.key !== this.props.location.key) {
  //     this.props.getPages()
  //   }
  // }

  componentWillUnmount() {
    this.props.resetPages()
  }

  componentDidMount() {
    this.props.getPages()

    if (this.props.auth.isAuthenticated) {
      this.props.qlikLoginSSO(this.props.auth)
    } else {
      this.props.history.push('/login')
    }
  }

  render() {
    const { pages, loading } = this.props
    const { classes, auth } = this.props

    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Pages </h2>
          </Header>

          <div className="u-m-xsmall">
            <Section>
              <Box component="span" className="full_height u-mb-small u-pb-large">
                {loading && (
                  <div className="u-text-center u-m-auto">
                    <Loading classes={classes} />
                  </div>
                )}
                {!loading && auth.user.role.toLowerCase() === 'admin' && isEmpty(pages) && (
                  <div className="row u-justify-center">
                    <div className="col-md-12 col-xl-12 u-m-auto u-mb-medium">
                      <Error
                        error="No pages found"
                        link={{
                          url: '/settings/pages/create',
                          title: 'New Page',
                        }}
                      />
                    </div>
                  </div>
                )}

                {!loading && auth.user.role.toLowerCase() === 'admin' && !isEmpty(pages) && (
                  <div className={' u-p-small'}>
                    <div className=" o-line u-p-small">
                      <h4 className={`c-card__title ${classes.colorPrimary}`}>Site Pages {pages.length}</h4>
                      <button
                        onClick={() => this.props.history.push('/settings/pages/create')}
                        className={`c-btn ${classes.buttonPrimary}`}
                      >
                        Create Page
                      </button>
                    </div>
                    <div className="c-table-responsive@wide">
                      <DataTable
                        title=""
                        className={'c-table'}
                        keyField={'_id'}
                        columns={this.columns}
                        data={pages}
                        pagination={true}
                        noHeader={true}
                        defaultSortField="title"
                      />
                    </div>
                  </div>
                )}

                {!loading && auth.user.role.toLowerCase() !== 'admin' && (
                  <AccessDenied props={{ classes, history: this.props.history }} />
                )}
              </Box>
            </Section>
          </div>
        </div>
      </AdminLayout>
    )
  }
}

Pages.propTypes = {
  auth: PropTypes.object.isRequired,
  resetPages: PropTypes.func,
  getPages: PropTypes.func.isRequired,
  editLandingPage: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  qlikLoginSSO: PropTypes.func.isRequired,
  pages: PropTypes.object,
  classes: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  loading: PropTypes.bool,
}
const mapStateToProps = state => ({
  auth: state.auth,
  pages: state.pages.pages,
  loading: state.pages.loading,
  errors: state.errors,
})
export default connect(mapStateToProps, {
  getPages,
  resetPages,
  qlikLoginSSO,
  editLandingPage,
})(withStyles(styles)(Pages))
